import React from 'react';
import { Provider } from 'react-redux';
import GlobalStyles from './assets/styles/globalStyle';
import store from './redux-new/store';
import AppProvider from './AppProvider';
import AppRouter from './router';
import { pmFindByIdRes } from './redux-new/sony-tool-prop-slice/sony-tool-prop-slice';

store.dispatch(pmFindByIdRes());

const App = () => (
  <Provider store={store}>
    <AppProvider>
      <>
        <GlobalStyles />
        <AppRouter />
      </>
    </AppProvider>
  </Provider>
);

export default App;
